<template>
  <div class="content" id="container">
    <el-form class="search-style">
      <el-row>
        <el-col :span="4">
          <el-form-item>
            <el-select v-model="params.column" @change="changeQueryParamsColumn">
              <el-option
                v-for="(item, index) in contractScreenCondition"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!--  星级 -->
        <!-- <el-col :span="4" v-if="params.column === 'starLevel'" style='padding-left:20px;'>
                <el-form-item>
                  <el-select v-model="params.value">
                    <el-option label="1星" value="1星"></el-option>
                    <el-option label="2星" value="2星"></el-option>
                  </el-select>
                </el-form-item>
        </el-col>-->
        <!--  重要等级 -->
        <el-col :span="4" v-if="params.column === 'cusImplevel'" style="padding-left:20px;">
          <el-form-item>
            <el-select v-model="params.value">
              <el-option label="重要" value="重要"></el-option>
              <el-option label="次要" value="次要"></el-option>
              <el-option label="普通" value="普通"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 数字验证 -->
        <el-col
          style="padding-left:20px;"
          :span="4"
          v-if="params.column === 'useCredit' || params.column === 'contractTotal' || params.column === 'count'"
        >
          <el-form-item>
            <el-select v-model="params.expression" text-align="center">
              <el-option
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
                v-for="(item, index) in expressionList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 文本输入框 -->
        <el-col :span="6" style="padding-left:20px;">
          <el-form-item>
            <el-input
              v-if="params.column !== 'cusImplevel'&& params.column !== 'starLevel'"
              v-model="params.value"
              clearable
              placeholder="请输入关键词"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4" style="padding-left:20px;">
          <el-form-item>
            <el-button @click="searchFor" type="primary">搜索</el-button>
            <el-button @click="searchReset" type>重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="box-table box-style" :style="{height:tableHeight+'px'}">
      <el-table
        ref="multipleTable"
        :max-height="tableHeight"
        :data="tableData"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        border
      >
        <el-table-column label="客户编号">
          <template slot-scope="scope">
            <span class="brand-border">{{ scope.row.cusCode || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column width="150px" show-overflow-tooltip label="客户名称">
          <template slot-scope="scope">
            <div
              class="line-limit-length approval"
              @click="cusName(scope.row)"
            >{{ scope.row.cusName || '--'}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="starLevel" label="星级">
          <template slot-scope="scope">
            <span class="brand-border">{{ scope.row.starLevel || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="useCredit" label="可用信用">
          <template slot-scope="scope">{{ scope.row.useCredit|priceFilterNum }}</template>
        </el-table-column>
        <el-table-column prop="contractTotal" label="贸易总额">
          <template slot-scope="scope">{{ scope.row.contractTotal|priceFilterNum }}</template>
        </el-table-column>
        <el-table-column prop="count" label="签订合同数量" width="120px">
          <template slot-scope="scope">
            <span class="brand-border">{{ String(scope.row.count) || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="badDebt" label="坏账">
          <template slot-scope="scope">{{ scope.row.badDebt|priceFilterNum }}</template>
        </el-table-column>
        <el-table-column width="100px" show-overflow-tooltip prop="bizAddress" label="公司地址">
          <template slot-scope="scope">
            <div class="brand-border line-limit-length">{{ scope.row.bizAddress || '--'}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="ccContacts" label="联系人">
          <template slot-scope="scope">
            <span class="brand-border">{{ scope.row.ccContacts || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ccPhone" width="100px" show-overflow-tooltip label="电话">
          <template slot-scope="scope">
            <div class="brand-border line-limit-length">{{ scope.row.ccPhone || '--'}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="ccMobile" width="100px" show-overflow-tooltip label="手机">
          <template slot-scope="scope">
            <div class="brand-border line-limit-length">{{ scope.row.ccMobile || '--'}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="cusImplevel" label="重要等级">
          <template slot-scope="scope">
            <span class="brand-border">{{ scope.row.cusImplevel || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="staffCnName" width="100px" show-overflow-tooltip label="当前负责人">
          <template slot-scope="scope">
            <div class="brand-border line-limit-length">{{ scope.row.staffCnName || '--'}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="clientName" label="委托人">
          <template slot-scope="scope">
            <span class="brand-border">{{ scope.row.clientName || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column width="150px" show-overflow-tooltip prop="createDate" label="添加时间">
          <template slot-scope="scope">
            <div class="line-limit-length">{{ scope.row.createDate|dateFilterL }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="signDate" width="150px" show-overflow-tooltip label="最后成单时间">
          <template slot-scope="scope">
            <div class="line-limit-length">{{ scope.row.signDate|dateFilterL }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination" style="padding-top:20px">
      <pagination
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
    </div>
  </div>
</template>

<script>
import { expressionList } from '@/components/utils/data'
import { queryAllCustomerListByClientId } from '@/api/customer/customerManage'
import pagination from '@/components/pagination'
export default {
  name: 'CustormTable',
  props: ['tab-active'],
  components: {
    pagination
  },
  mounted() {
    this.getList()
  },
  data() {
    return {
      expressionList: expressionList,
      contractScreenCondition: [
        { value: 'cusName', label: '客户名称' },
        // { value: 'useCredit', label: '可用信用' },
        // { value: 'contractTotal', label: '贸易总额' },
        // { value: 'count', label: '签订合同数量' },
        // { value: 'badDebt', label: '坏帐' },
        { value: 'ccContacts', label: '联系人' },
        { value: 'ccPhone', label: '电话' },
        { value: 'ccMobile', label: '手机' },
        // { value: 'starLevel', label: '星级' },
        { value: 'cusImplevel', label: '重要等级' }
      ],
      productType: '',
      height: 0,
      params: {
        column: 'cusName',
        expression: 'eq',
        value: ''
      },
      tableData: [],
      addCustormRuleform: {
        custormName: '', // 客户名称
        industry: '', // 所属行业
        user: '', // 联系人
        phone: '', // 联系电话
        telPhone: '' // 联系手机
      },
      addCustormRules: {
        custormName: [{ required: true }]
      },
      total: 0,
      currentPage: 1,
      pageSize: 30,
      tableHeight: window.innerHeight - 340,
      addCustormDialog: false, // 添加客户弹框
      serchList: []
    }
  },
  created() {
    this.height = document.documentElement.clientHeight
  },
  watch: {
    params(val) {
      if (!val.column) {
        this.$set(this.params, 'column', 'cusName')
      }
    }
  },
  methods: {
    getList() {
      this.loadingTable = true
      this.list = []
      this.params.collection = true
      const params = {
        criteriaVoList: [...this.serchList],
        queryPageName: ''
      }
      queryAllCustomerListByClientId(this.currentPage, this.pageSize, params)
        .then(res => {
          if (res.data.code === 200) {
            setTimeout(() => {
              this.loadingTable = false
              this.tableData = res.data.obj.records
              this.total = res.data.obj.total
            }, 200)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    searchFor() {
      if (
        this.params.column === undefined ||
        this.params.value === '' ||
        this.params.value === null
      ) {
        this.$message.error('搜索条件不能为空')
      } else {
        this.serchList = [this.params]
        this.pageSize = 30
        this.currentPage = 1
        this.getList()
      }
    },
    searchReset() {
      this.params = {}
      this.serchList = []
      this.getList()
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    // 添加客户
    addCustormQuickly() {
      this.addCustormDialog = true
    },
    changeQueryParamsColumn() {
      delete this.params.value
      this.params.expression = 'eq'
    },
    cusName(row) {
      this.$router.push({
        path: '/crm/customer/details',
        query: { id: row.id }
      })
    }
  },
  filters: {
    numFilter
  }
}
function numFilter(num) {
  return !num ? '--' : parseFloat(num).toFixed(2)
}
</script>

<style></style>
